<template>
  <div class="mb-5">
    <h4>Create New Bot</h4>
    <img
      src="/assets/img/covid19tracker/1-enter-token.PNG"
      alt="enter token"
      class="img-fluid my-3"
    />
    <p>Click on "MY BOTS" in the navigation bar, In this page, you can see all your bots. To create a new bot copy-paste the token obtained from the BoFather in the above input field and click "Create New Bot" button.</p>

    <img :src="src" alt="bot card" class="img-fluid my-3" />
    <p>Now your bot is linked with Bot Creator. You need to define your chat flows to make it operational. Click on edit to create chat flows.</p>
  </div>
</template>

<script>
export default {
    props:{
        src: String
    }
};
</script>

<style>
</style>